import {
	FETCH_SURVEY_SCORES_REQUEST,
	FETCH_SURVEY_SCORES_SUCCESS,
	FETCH_SURVEY_SCORES_FAIL,
	UPDATE_SURVEY_SCORE_REQUEST,
	UPDATE_SURVEY_SCORE_SUCCESS,
	UPDATE_SURVEY_SCORE_FAIL,
	FETCH_SURVEY_SCORE_REQUEST,
	FETCH_SURVEY_SCORE_SUCCESS,
	FETCH_SURVEY_SCORE_FAIL,
} from "../constants/surveyScore";

function fetchSurveyScoresReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", surveyScores: {}, error: null };
	}
	switch (action.type) {
		case FETCH_SURVEY_SCORES_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SURVEY_SCORES_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				surveyScores: action.payload,
			};
		case FETCH_SURVEY_SCORES_FAIL:
			return { loading: false, status: "FAILED", error: action.payload };
		default:
			return state;
	}
}

function updateSurveyScoreReducer(state, action) {
	if (typeof state === "undefined") {
		state = {};
	}
	switch (action.type) {
		case UPDATE_SURVEY_SCORE_REQUEST:
			return { loading: true };
		case UPDATE_SURVEY_SCORE_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
			};
		case UPDATE_SURVEY_SCORE_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

function fetchSurveyScoreReducer(state, action) {
	if (typeof state === "undefined") {
		state = { status: "IDLE", surveyScore: {}, error: null };
	}
	switch (action.type) {
		case FETCH_SURVEY_SCORE_REQUEST:
			return { loading: true, status: "IDLE" };
		case FETCH_SURVEY_SCORE_SUCCESS:
			return {
				loading: false,
				status: "SUCCEEDED",
				surveyScore: action.payload,
			};
		case FETCH_SURVEY_SCORE_FAIL:
			return { loading: false, status: "FAILED" };
		default:
			return state;
	}
}

export {
	fetchSurveyScoresReducer,
	updateSurveyScoreReducer,
	fetchSurveyScoreReducer,
};
